<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 md6 lg6>
          <h1 class="headline">{{ $t('rates.title') }}</h1>
        </v-flex>

        <v-flex xs12 sm6 md6 lg6>
          <v-layout wrap align-center justify-end>
            <v-btn
              v-if="$can('rent_rate_add')"
              color="warning mt-2"
              large
              depressed
              @click="dialog = true"
            >
              {{ $t('rates.add') }}
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-data-table
        class="rates-table"
        :headers="headers"
        :items="items"
        :loading="loading"
        hide-default-footer
      >
        <template #item="{item}">
          <tr>
            <td>{{ item.num }}</td>
            <td>
              <button
                class="edit-btn"
                @click="
                  () => {
                    editItem = item;
                    dialog = true;
                  }
                "
              >
                {{ item.name }}
              </button>
            </td>
            <td>{{ item.rate }}</td>
            <td>{{ item.description || '-' }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>

    <rate-dialog
      v-model="dialog"
      :item="editItem"
      @updated="proccessResult"
      @close="editItem = null"
    />

    <v-snackbar v-model="snack.value" :color="snack.color" bottom right>
      {{ snack.message }}
    </v-snackbar>
  </v-layout>
</template>

<script>
import RateDialog from '@/components/rates/RateDialog.vue';

export default {
  components: { RateDialog },
  data: () => ({
    loading: false,
    dialog: false,

    editItem: null,

    snack: {
      value: false,
      color: null,
      message: null,
    },
  }),
  computed: {
    headers() {
      return [
        { text: this.$t('common.number'), value: 'num', sortable: false },
        {
          text: this.$t('companiesList.tableHeaders.name'),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$t('common.table.percent'),
          value: 'rate',
          sortable: false,
        },
        {
          text: this.$t('common.table.description'),
          value: 'description',
          sortable: false,
        },
      ];
    },
    items() {
      return this.$store.state.rates.list;
    },
  },
  methods: {
    proccessResult({ success, error }) {
      const snack = {
        value: true,
        color: 'success',
        message: this.$t('common.saved'),
      };

      if (error) {
        snack.color = 'error';
        snack.message = this.$t('common.errors.APIerror');
      }

      if (success) {
        this.dialog = false;
      }

      this.snack = snack;
    },
  },
  async created() {
    this.loading = true;
    await this.$store.dispatch('rates/fetchList');
    this.loading = false;
  },
};
</script>

<style>
.rates-table {
  margin-top: 70px;
}

.edit-btn {
  font-weight: 600;
  color: #464646;
  text-decoration: underline;
}

.edit-btn:not([disabled]):hover {
  text-decoration: none;
}

.edit-btn[disabled] {
  opacity: 0.7;
}
</style>
